// --------------------------------------------------------------
// Last Modified: 2025-10-27
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./InfoBanner.module.scss";

// Info message.
export default function InfoBanner(props: Props): Component {
  return props.message.length > 0 ? (
    <div data-test="info-banner" className={`${styles.body} alert alert-info`} role="alert">
      <span>{props.message}</span>
      {props.children !== undefined && props.children}
    </div>
  ) : null;
}

interface Props {
  message: string;
  children?: Children;
}
